<style>
.bg-primary {
  background-color: #1a3665 !important;
}
</style>
<template>
<div>
  <div class="row">
    <div class="col-xl-6 col-md-6 col-sm-12">
      <div class="card bg-primary text-white">
        <div class="row">
          <div class="col-md-9">
            <div class="card-body">
              <div class="mb-3">
                <h3>{{ detailUser.nama_lengkap }}</h3>
              </div>
            </div>
          </div>
          <div class="col-md-3 mt-3 mb-3">
            <i
              style="    
                height: 40px;
                width: 40px;
                opacity: 0.8;
                float: right;
                margin-right: 13px;"
              class="c-sidebar-nav-icon fa fa-user opacity-7"
            ></i>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-6 col-md-6 col-sm-12">
      <div class="card bg-primary text-white">
        <div class="row">
          <div class="col-md-9">
            <div class="card-body">
              <div class="mb-3">
                <h3>{{ detailUser.nama_rpl }}</h3>
              </div>
            </div>
          </div>
          <div class="col-md-3 mt-3 mb-3">
            <i
              style="    
                height: 40px;
                width: 40px;
                opacity: 0.8;
                float: right;
                margin-right: 13px;"
              class="c-sidebar-nav-icon fas fa-file-alt opacity-7"
            ></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <CCard>
    <div
      class="card-header bg-primary font-weight-bold text-white"
      style="display: flex; align-items: center;"
    >
      Data Dokumen Pengajuan Sertifikat Yaman
      <Button
        @click="$router.go(-1)" 
        class="btn btn-md btn-dark px-4 py-2 text-white ml-auto"
        >Kembali</Button>
    </div>
    <CCardBody>
      <CRow>
        <CCol sm="6" lg="12">
          <div class="card border-0">
            <div class="card-body">
              <div class="table-responsive">
                <CDataTable :items="itemDokumen" :fields="fields" hover sorter>
                  <template #no={index}>
                    <td>
                      {{ index +1 }}
                    </td>
                  </template>
                  <template #statusWajib="{item}">
                    <td 
                      class="font-weight-bold text-left"
                      :class="{
                        'text-success': item.statusWajib == '1',
                        'text-danger': item.statusWajib == '0',
                      }"
                    >
                      {{ item.statusWajib == '1' ? 'Wajib' : 'Tidak Wajib' }}
                    </td>                   
                  </template>  
                  <template #statusUpload="{item}">
                    <td
                      class="font-weight-bold text-secondary"
                      v-if="item.statusUpload == '0'"
                    >Belum Upload</td>
                    <td
                      class="font-weight-bold text-success"
                      v-if="item.statusUpload ==   '1'"
                    >Terverifikasi</td>
                    <td
                      class="font-weight-bold text-primary"
                      v-if="item.statusUpload ==   '2'"
                    >Sudah Upload</td>
                    <td
                      class="font-weight-bold text-info"
                      v-if="item.statusUpload ==      '3'"
                    >File Tidak Terbaca</td>
                    <td
                      class="font-weight-bold text-danger"
                      v-if="item.statusUpload ==    '4'"
                    >File Tidak Sesuai</td>
                  </template>
                  <template #aksi="{item}">
                    <td class="py-2">
                      <CButton
                        class="btn-sm text-white mr-2"
                        square
                        color="warning"
                        :disabled="item.file == ''"
                        @click="bukaFile(item.file)"
                        v-c-tooltip="'Lihat File'"
                      >
                        <small><i class="fa fa-eye"  ></i></small>
                      </CButton>
                      <CButton
                        color="info"
                        class="btn-sm text-white"
                        square
                        v-c-tooltip="'Verifikasi'"
                        @click="verifikasiDokumen(item.idDokumenPendukungPeserta,item.statusUpload, item.alasan)"
                      >
                      <small><i class="fa fa-check"  ></i></small>
                      </CButton>
                      
                      
                    </td>
                  </template>
                
                </CDataTable>
              </div>
            </div>
          </div>
        </CCol>
      </CRow>
      <!-- Modal Verifikasi -->
      <CModal
        title="Modal title"
        :show.sync="modalVerif"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CForm>
          <CRow>
            <CCol sm="12">
              <label for class="font-weight-bold">Diverifikasi Pada</label>
              <br />
              <CInput class="font-weight-bold" type="date" />
            </CCol>

           
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Verifikasi Data Dokumen</h6>
        </template>
        <template #footer>
          <CButton @click="modalVerif = false" color="danger">Tutup</CButton>
          <CButton @click="modalVerif = false" type="submit" color="success">Simpan</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
      <CModal
        title="Modal title"
        :show.sync="modalEmail"
        :no-close-on-backdrop="true"
        :centered="true"        
      >
        <CForm>
          <CRow>
            <CCol sm="12">
              <CInput class="font-weight-bold" label="Subjek" placeholder="Masukkan Subjek" />
            </CCol>
            <CCol sm="12">
              <CTextarea
                class="font-weight-bold"
                label="Pesan"
                rows="3"
                placeholder="Masukkan isi pesan"
              />
            </CCol>

            <CCol sm="12 mb-5">
              <label for="uid-zwqayuopq3" class="font-weight-bold">File (Opsional)</label>
              <br />
              <div class="custom-file text-truncate">
                <input type="file" class="custom-file-input" id="validatedCustomFile" />                
                <label class="custom-file-label" for="validatedCustomFile">Choose file</label>
              </div>
            </CCol>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Kirim Email</h6>
        </template>
        <template #footer class="mt-5">
          <CButton @click="modalEmail = false" color="danger">Tutup</CButton>
          <CButton type="submit" color="success">Kirim</CButton>
        </template>
      </CModal>
      <!-- Modal Verifikasi -->
        <CModal
          title="Modal title"
          :show.sync="modalVerif"
          :no-close-on-backdrop="true"
          :centered="true"
        >
          <CForm>
            <CRow>
              <CCol sm="12 mb-4">
                <label for class="font-weight-bold">Status</label>
                <br />
                <select name="id_outlet" v-model="formData.statusUpload" class="form-control mb-2">
                  <option value="1" :selected="formData.statusUpload == '1'">Terverifikasi</option>
                  <option value="3" :selected="formData.statusUpload == '3'">File Tidak Terbaca</option>
                  <option value="4" :selected="formData.statusUpload == '4'">File Tidak Sesuai</option>
                </select>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" v-if="formData.statusUpload != '1'">
                <label for class="font-weight-bold">Alasan <span>(Opsional)</span></label>
                <textarea class="form-control" name="" id="" cols="30" rows="4" v-model="formData.alasan" placeholder="Masukkan alasan"></textarea>
              </CCol>
            </CRow>
          </CForm>
          <template #header>
            <h6 class="modal-title h5 font-weight-bold">Verifikasi Data Dokumen</h6>
          </template>
          <template #footer>
            <CButton @click="modalVerif = false" color="danger">Tutup</CButton>
            <CButton type="submit" @click="verif" color="success">Simpan</CButton>
          </template>
        </CModal>
        <!-- End Modal -->
    </CCardBody>
  </CCard>
</div>
</template>
<script>
import DataKeanggotaanService from "../../../services/keanggotaan/data-anggota.service";
import PengajuanPenerbitanSertifikatRplService from "../../../services/rpl/data-penerbitan-sertifikat-rpl.service"
import Utils from "../../../services/utils.service";
const fields = [
  { key: "no" },
  {
    key: "namaDokumen",
    label: "Nama Dokumen"
  },
  {
    key: "statusWajib",
    label: "Status Dokumen",
    sorter: true,
    filter: false,    
  },
  {
    key: "statusUpload",
    label: "Status Dokumen",
    sorter: true,
    filter: false
  },

  {
    key: "aksi",
    _style: "width:11%; text-align: center",
    sorter: false,
    filter: false
  }
]
// https://dev-fo-user.birutekno.com/dokumen_penerbitan_sertifikasi
export default {
  data() {
    return {
      details: {},
      detailUser: {},
      fields,
      masterDokumen: [],
      itemDokumen : [],
      dokumenPeserta: [],
      formData: {
        idDokumenPendukungPeserta: "",
        statusUpload: "",
        alasan: "",
        verifikasiPada: new Date().toISOString().slice(0, 10)
      },
      no: 1,
      status: false,
      modalVerif: false,
      modalEmail: false,
      horizontal: { label: "col-3", input: "col-9" },

      collapseDuration: 0,
      index: 0,
      content: []
    };
  },
  mounted() {
    this.getData(this.$route.params.id_pengajuan_penerbitan);
  },
  methods: {
    getData(id) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      PengajuanPenerbitanSertifikatRplService.getDetailData(id)
      .then(response => {
        // comment console console.log(response);
        loader.hide()
        this.itemDokumen = response.data.singleData.data_dokumen
        this.detailUser = {
          nama_lengkap : response.data.singleData.nama_lengkap,
          nama_rpl : response.data.singleData.nama_rpl
        }
      }).catch(error => {
        // comment console console.log(error);
        loader.hide()
        
      })
    },
    
    bukaFile(file) {
      
      let user = JSON.parse(localStorage.getItem('user'));
      let token = user.accessToken
      let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
width=0,height=0,left=-1000,top=-1000`;
      window.open(
        Utils.baseurlFoUsers() + "/lihat-file/"+file+"/lokasi/data_dokumen_pendukung/bearer/" + token,
        file,
        params
      );
    },

    alertVerif() {
      var vm = this;
      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Data Berhasil Verifikasi"
      });
    },

    verifikasiDokumen(idDokumenPendukungPeserta, statusUpload, alasan) {
      this.modalVerif = true;
      this.formData.idDokumenPendukungPeserta = idDokumenPendukungPeserta;
      this.formData.statusUpload = statusUpload;
      this.formData.alasan = alasan;
      
    },
    verif() {
      var vm = this;
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });

      var vm = this;
      DataKeanggotaanService.verifikasiDataDokumen(this.formData)
        .then(response => {
          // comment console console.log(response);
          this.modalVerif = false;
          this.alertVerif();
          this.getData(this.$route.params.id_pengajuan_penerbitan);
          loader.hide();
        })
        .catch(error => {
          // comment console console.log(error);
          loader.hide();
        });
    }
  }
};
</script>
